// Централизованные константы пагинации

// Базовые размеры для FullHD (1920x1080) - используются как fallback
// Для адаптивной пагинации используйте хук useAdaptivePageSize
export const DEFAULT_INTERVIEWS_PAGE_SIZE = 10;
export const DEFAULT_VACANCIES_PAGE_SIZE = 5;
export const DEFAULT_TEAM_PAGE_SIZE = 7;
export const DEFAULT_COMPANIES_PAGE_SIZE = 6;
export const DEFAULT_ACCOUNTS_PAGE_SIZE = 6;
export const DEFAULT_COMPLAINTS_PAGE_SIZE = 7;

// Пороги высоты окна для масштабирования
export const SCALE_THRESHOLDS = {
  LARGE: 1200,    // 2K мониторы без DevTools
  MEDIUM: 900,    // Средние окна
  SMALL: 850,     // Малые окна с DevTools
} as const;

// Коэффициенты масштабирования для вакансий
export const VACANCIES_SCALE_FACTORS = {
  LARGE: 1.4,     // 4K: 5 × 2.0 = 10 элементов
  MEDIUM: 1.6,    // 2K: 5 × 1.6 = 8 элементов
  SMALL: 1.6,     // 2K с DevTools: 5 × 1.6 = 8 элементов
  DEFAULT: 1.0,   // FullHD: 5 × 1.0 = 5 элементов
} as const;

// Коэффициенты масштабирования для собеседований
export const INTERVIEWS_SCALE_FACTORS = {
  LARGE: 1.8,     // 4K: 10 × 2.0 = 20 элементов
  MEDIUM: 1.5,    // 2K: 10 × 1.5 = 15 элементов
  SMALL: 1.5,     // 2K с DevTools: 10 × 1.5 = 15 элементов
  DEFAULT: 1.0,   // FullHD: 10 × 1.0 = 10 элементов
} as const;

// Экспорт для совместимости с существующим кодом
// Рекомендуется использовать useAdaptivePageSize для новых компонентов
// Прямые импорты хуков/утилит из этого файла удалены, чтобы избежать циклических зависимостей

